const STORAGE = {
  //
  // ─── AUTH ───────────────────────────────────────────────────────────────────────
  //
  authToken: "auth:token",
  authMemberDetails: "memberDetails",
  authMemberBasicDetails: "memberBasicDetails",
  // cookiePolicyAccepted: "app:cookiePolicyAccepted",
  // cookiePolicyAcceptedValue: "1",
  cookiePolicies: "app:cookiePolicies",

  //
  // ─── APP ────────────────────────────────────────────────────────────────────────
  //
  clientUnique: "app:clientUnique",
  sessionId: "app:sessionId",
  loanFlowParams: "app:loanFlowParams:",
  loanFlowIdFromLoanApply: "app:loanFlowIdFromLoanApply:",
  hasActiveLoan: "app:hasActiveLoan",
  reduxPersistPrefix: "myk:store_persist:",
  hint: btoa("otp-pin-hint-values"),
  campaignParams: "campaignParams",
  campaignInfo: "campaignInfo",
  repayTokenForPayment: "repayTokenForPayment",
  hasPinRecentlyRequested: "hasPinRecentlyRequested",
  userApplicationLandingPage: "userApplicationLandingPage",
  widgetSessionId: "loanRequest:widgetSessionId",
  marketingPopUpLastShown: "app:marketingPopUp",
  affiliateSessionId: "app:affiliateSessionId",
  conektaSession: "app:conektaSession",
  bizumRolloverSession: "app:bizumRolloverSession",
  bizumRestructureSession: "app:bizumRestructureSession",
  hasSeenOverdueModal: "app:hasSeenOverdueModal",
  shouldShowWelcomeMessage: "app:shouldShowWelcomeMessage",
  hasSeenDiscountModal: "app:hasSeenDiscountModal",
  hasBeenRedirectedToCardUploadPage: "app:hasBeenRedirectedToCardUploadPage",
  requestedPhoneNumber: "requestedPhoneNumber",
  tinkCredentialsId: "tinkCredentialsId",
  applyIntentLog: "applyIntentLog",
  handoverCompletedTimestamp: "app:handoverCompletedTimestamp",

  pendingPaymentPayload: "app:pendingPaymentPayload",
  pendingRolloverPayload: "app:pendingRolloverPayload",
  pendingRestructurePayload: "app:pendingRestructurePayload",
};

export default STORAGE;
